import { DashboardTimeFrame } from 'containers/dashboard/types/types';

export const defaultActiveCostCodeDashboardCardTimeFrame: DashboardTimeFrame = 'pastFourteen';
